import React from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";
import '../App.css';
// import styles from "../index.css"


function Footer() {
  return (
    <div className="footer">
      <h6>IM JUST A FOOTER. SITTIN RIGHT HERE AT THE BOTTOM OF THE PAGE. I'M SUPPOSED TO TELL YOU USEFUL INFORMATION LIKE WHERE THE ART PIECE IS FROM. PRETTY NICE PHOTO RIGHT? IT'S FROM DRIBBBLE. CHECK OUT <a href="https://dribbble.com/roberlan">ROBERLAN'S ART HERE</a>. WHAT ELSE YA WANA KNOW? HOW TO REACH ME? SURE, JUST LOOK FOR MY CONTACT ON THE ABOUT PAGE. WHAT ELSE? WHAT I BUILT THIS PAGE WITH? WOW, YOU ASK A LOT MAN BUT OK. IT'S WITH REACT AND TAILWIND.</h6>
    </div>
    );
}

export default Footer;
